var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pointer", class: _vm.styleClass },
    [
      _c(
        "vue-dropzone",
        {
          ref: "myVueDropzone",
          attrs: {
            id: "dropzone",
            "duplicate-check": true,
            options: _vm.dropzoneOptions,
            "use-custom-slot": true
          },
          on: {
            "vdropzone-sending": _vm.beforeUpload,
            "vdropzone-success": _vm.afterUploadSuccess,
            "vdropzone-error": _vm.afterUploadError,
            "vdropzone-file-added": _vm.afterFileAdded
          }
        },
        [
          _vm.src && !_vm.addingFile
            ? [
                _c("i", {
                  staticClass: "fa fa-pencil",
                  attrs: { "aria-hidden": "true" }
                }),
                _vm._v(" "),
                _c(
                  "i",
                  {
                    staticClass: "fa fa-icon",
                    attrs: { "aria-hidden": "true" },
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        return _vm.deleteImage($event)
                      }
                    }
                  },
                  [_c("span", { staticClass: "mod-icon-clear" })]
                )
              ]
            : !_vm.addingFile
              ? [
                  _c("div", { staticClass: "upload-wrapper" }, [
                    _c("div", [
                      _c("div", [_c("i", { staticClass: "fa fa-upload" })]),
                      _vm._v(" "),
                      _c("label", {
                        directives: [
                          {
                            name: "dompurify-html",
                            rawName: "v-dompurify-html",
                            value: _vm.label,
                            expression: "label"
                          }
                        ]
                      }),
                      _vm._v(" "),
                      _vm.recommended
                        ? _c("div", { staticClass: "upload-recommended" }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.recommended) +
                                "\n          "
                            )
                          ])
                        : _vm._e()
                    ])
                  ])
                ]
              : [_c("div")]
        ],
        2
      ),
      _vm._v(" "),
      _c("div", { staticClass: "error-text" }, [_vm._v(_vm._s(_vm.error))])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-66643bec", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-66643bec","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FilesUploadGallery.vue
// module id = null
// module chunks = 